import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { consumeReturnUrl } from "../utils/authReturn";

function tokensFromLocation(searchParams) {
  // Prefer hash fragment (SEC: not sent to server / logs) — #55.
  const hash = window.location.hash?.replace(/^#/, "") || "";
  if (hash) {
    const fromHash = new URLSearchParams(hash);
    const access = fromHash.get("access");
    const refresh = fromHash.get("refresh");
    if (access && refresh) return { access, refresh };
  }
  // Legacy query fallback during deploy overlap.
  const access = searchParams.get("access");
  const refresh = searchParams.get("refresh");
  if (access && refresh) return { access, refresh };
  return null;
}

const GoogleSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("common");

  useEffect(() => {
    const tokens = tokensFromLocation(searchParams);

    if (tokens) {
      localStorage.setItem("access_token", tokens.access);
      localStorage.setItem("refresh_token", tokens.refresh);
      // Drop tokens from URL bar.
      window.history.replaceState(null, "", "/google-success");
      navigate(consumeReturnUrl("/"), { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [navigate, searchParams]);

  return (
    <p>
      {t("auth.googleAuthPending", {
        defaultValue: "Авторизація через Google...",
      })}
    </p>
  );
};

export default GoogleSuccessPage;
